import React from 'react'
import PropTypes from 'prop-types'
import { Card, Empty } from 'antd'
import { Bar } from 'react-chartjs-2'
import { barData, barOptions } from './utils'

// A grouped bar chart of activity by weekday (Mon–Sun): completed conversations and payments, so
// the team can see which days are busiest vs. slowest. Also calls out the peak day in the header.
const WeekdayActivity = ({ data }) => {
  const labels = (data && data.labels) || []
  const series = (data && data.series) || []
  const hasData = series.some(s => (s.data || []).some(n => n > 0))

  // Peak day across both series combined, for a quick headline.
  let peak = null
  if (hasData) {
    const totals = labels.map((_, i) =>
      series.reduce((sum, s) => sum + ((s.data && s.data[i]) || 0), 0)
    )
    const max = Math.max(...totals)
    if (max > 0) peak = labels[totals.indexOf(max)]
  }

  return (
    <Card
      title="Busiest days of the week"
      extra={
        peak ? (
          <span style={{ color: '#3f8600', fontWeight: 600 }}>Peak: {peak}</span>
        ) : null
      }
      style={{ height: '100%' }}
    >
      {!hasData ? (
        <Empty description="No activity for this period" />
      ) : (
        <div style={{ height: 260 }}>
          <Bar data={barData(data)} options={barOptions} />
        </div>
      )}
    </Card>
  )
}

WeekdayActivity.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.array,
    series: PropTypes.array
  })
}

export default WeekdayActivity
